export function setListing(listing){
  return{type:'SET_LISTING', listing}
}